export default __webpack_public_path__ + "static/media/lc-banner-logo.08212dff.svg";